import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke={fill || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.395 14.5h4.21l-4.21 5h4.21M21 9.5l-2.5-5-2.5 5M16.419 8.662h4.162M12 19.5H3M12 14.5H3M12 9.5H3M12 4.5H3"
    />
  </svg>
);
export default SvgComponent;
